/**
 * @generated SignedSource<<6010dd507fae4024a323da4dbfecae63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CommentsDeleteCommentMutation$variables = {
  id: string;
};
export type CommentsDeleteCommentMutation$data = {
  readonly Comment_Delete: {
    readonly comment: {
      readonly id: string;
      readonly isDeleted: boolean;
    };
  } | null;
};
export type CommentsDeleteCommentMutation = {
  response: CommentsDeleteCommentMutation$data;
  variables: CommentsDeleteCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "commentId",
        "variableName": "id"
      }
    ],
    "concreteType": "DeleteComment",
    "kind": "LinkedField",
    "name": "Comment_Delete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "comment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDeleted",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsDeleteCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentsDeleteCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "72c610616a760bbc1f95ce7095e58f2f",
    "id": null,
    "metadata": {},
    "name": "CommentsDeleteCommentMutation",
    "operationKind": "mutation",
    "text": "mutation CommentsDeleteCommentMutation(\n  $id: ID!\n) {\n  Comment_Delete(commentId: $id) {\n    comment {\n      id\n      isDeleted\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4d1a3c4c7dd3f21de7d24f538ba0158a";

export default node;
